import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, TextInput, Textarea, Button, Group,Title } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import {useForm} from "@mantine/form"
 
const ModalEditorResource =({opened, onClose , onSave , resourceData })=>{

  const { recursos } = useSelector((state) => state.improvementPlan);

  const form = useForm({
    initialValues: { 
      titulo: resourceData?.titulo ?? "", 
      descripcion: resourceData?.descripcion ?? "",
    },
    validate: {
      titulo: (value) => (value.trim() ? null : "El título es obligatorio"),
    },
  });

  useEffect(() => {
    if (resourceData) {
      form.setValues({
        titulo: resourceData?.titulo ?? "",
        descripcion: resourceData?.descripcion ?? "",
      });
    } else {
      form.reset();
    }
  }, [resourceData]);

  const handleSubmit = () => {
    if (!form.validate().hasErrors) {
      const saveResource = {
        titulo: form.values.titulo,
        descripcion: form.values.descripcion,
      };
      
      if (resourceData) {
        saveResource.Id = resourceData.Id;
      }

      onSave(saveResource);
    }
  };


  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Title fw={400} c={"#E72166"} size={"28px"}>
          {resourceData ? "EDITAR RECURSO" : "CREAR RECURSO"}
        </Title>
      }
      centered
      size="lg"
    >
      <TextInput
        withAsterisk
        label="Nombre"
        placeholder="Ingrese el nombre del recurso"
        {...form.getInputProps("titulo")}
      />

      <Textarea
        label="Descripción"
        placeholder="Ingrese la descripción"
        mt="md"
        autosize
        minRows={2}
        maxRows={4}
        {...form.getInputProps("descripcion")}
      />
      <Button fullWidth mt="md" color="#E72166" onClick={handleSubmit} loading={recursos.saving}>
        Guardar Recurso
      </Button>
    </Modal>
  );
};

export default ModalEditorResource;